const TICKET_LIST_SUBPATHS = new Set([
  'channels',
  'imports',
  'quick-messages',
  'queues',
  'tags',
  'schedules',
  'conversation',
]);

/**
 * Converte URLs legadas (ex.: /atendimentos/conversa/:id) para rotas atuais do SPA.
 * Usado em push notifications, drawer de notificações e redirects de compatibilidade.
 *
 * @param {string | null | undefined} rawUrl
 * @param {string} [origin] - origin atual (window.location.origin) para URLs absolutas internas
 * @returns {string}
 */
export function normalizeNotificationUrl(rawUrl, origin) {
  if (!rawUrl || rawUrl === '/') return '/tickets/conversation';

  let pathname = rawUrl;
  let suffix = '';

  try {
    if (/^https?:\/\//i.test(rawUrl)) {
      const parsed = new URL(rawUrl);
      if (origin && parsed.origin !== origin) return rawUrl;
      pathname = parsed.pathname;
      suffix = `${parsed.search}${parsed.hash}`;
    } else {
      const hashIdx = rawUrl.indexOf('#');
      const queryIdx = rawUrl.indexOf('?');
      const cutIdx =
        hashIdx >= 0 && queryIdx >= 0 ? Math.min(hashIdx, queryIdx) : Math.max(hashIdx, queryIdx);
      if (cutIdx >= 0) {
        pathname = rawUrl.slice(0, cutIdx);
        suffix = rawUrl.slice(cutIdx);
      }
    }
  } catch {
    return '/tickets/conversation';
  }

  const normalizedPath = pathname.replace(/\/+$/, '') || '/';

  const legacyConversation = normalizedPath.match(/^\/atendimentos\/conversa(?:\/(.*))?$/);
  if (legacyConversation) {
    const ticketId = legacyConversation[1]?.replace(/\/$/, '');
    return ticketId
      ? `/tickets/conversation/${ticketId}${suffix}`
      : `/tickets/conversation${suffix}`;
  }

  const directTicket = normalizedPath.match(/^\/tickets\/([^/]+)$/);
  if (directTicket && !TICKET_LIST_SUBPATHS.has(directTicket[1])) {
    return `/tickets/conversation/${directTicket[1]}${suffix}`;
  }

  return `${normalizedPath}${suffix}`;
}

export function isInternalAppUrl(url, origin) {
  if (!url) return false;
  if (!/^https?:\/\//i.test(url)) return url.startsWith('/');
  try {
    return !origin || new URL(url).origin === origin;
  } catch {
    return false;
  }
}
